// The Family Members card saves when the user leaves it; the next card (WealthConnect)
// waits for that save so it never loads a stale member list.
let pending = Promise.resolve();

export const queueFamilySave = (save) => {
  pending = pending.catch(() => {}).then(save);
  return pending;
};

export const whenFamilySaved = () => pending.catch(() => {});
